export const frontmatter = {
    "draft": true,
    "title": "Integración WhatsApp",
    "description": "Configura la integración de WhatsApp en OnnIA para enviar y recibir mensajes.",
    "sidebar_label": "WhatsApp",
    "sidebar_group": "guías",
    "sidebar_order": 1
}

export const toc = []